import React, { ReactNode } from "react";
import styles from '../LinkPersonalizado7/linkPersonalizado7.module.scss';
import { Link } from "react-router-dom";

interface LinkPersonalizado7Props {
    href: string;
    title: string;
    icon: ReactNode;
    colorText: string;
    noLink?: boolean;
    linkInterno?: boolean;
    spaceBetween?: boolean;
    topLeft?: boolean;
    topRight?: boolean;
}

const LinkPersonalizado7: React.FC<LinkPersonalizado7Props> = ({
    href,
    title,
    icon,
    colorText,
    noLink = false,
    linkInterno = false,
    spaceBetween = false,
    topLeft = false,
    topRight = false,
}) => {
    return (
        noLink ?
            <div
                rel="noreferrer"
                style={
                    topLeft ?
                        {
                            gridColumn: "1 / span 2",
                            gridRow: "1",
                            justifySelf: "center",
                            position: "relative",
                            textDecoration: "none",
                            display: "flex",
                            justifyContent: spaceBetween ? "space-between" : "end",
                            flexDirection: "column"
                        } : topRight ?
                            {
                                gridColumn: "2 / span 2",
                                gridRow: "1",
                                justifySelf: "center",
                                position: "relative",
                                textDecoration: "none",
                                display: "flex",
                                justifyContent: spaceBetween ? "space-between" : "end",
                                flexDirection: "column"
                            } :
                            {
                                position: "relative",
                                textDecoration: "none",
                                display: "flex",
                                justifyContent: spaceBetween ? "space-between" : "end",
                                flexDirection: "column"
                            }
                }
            >
                <div style={{ marginBottom: "0.5rem", display: "flex", justifyContent: "center" }}>{icon}</div>
                <div className="d-flex align-items-center justify-content-center">
                    <div className={styles["min-w-span"]} style={{ lineHeight: 0.7 }}>
                        <span className={styles["span"]} style={{ color: colorText, fontWeight: "bold" }}>{title}</span>
                    </div>
                </div>
            </div>
            :
            linkInterno ?
                <Link
                    to={href}
                    rel="noreferrer"
                    style={
                        topLeft ?
                            {
                                gridColumn: "1 / span 2",
                                gridRow: "1",
                                justifySelf: "center",
                                position: "relative",
                                textDecoration: "none",
                                display: "flex",
                                justifyContent: spaceBetween ? "space-between" : "end",
                                flexDirection: "column"
                            } : topRight ?
                                {
                                    gridColumn: "2 / span 2",
                                    gridRow: "1",
                                    justifySelf: "center",
                                    position: "relative",
                                    textDecoration: "none",
                                    display: "flex",
                                    justifyContent: spaceBetween ? "space-between" : "end",
                                    flexDirection: "column"
                                } :
                                {
                                    position: "relative",
                                    textDecoration: "none",
                                    display: "flex",
                                    justifyContent: spaceBetween ? "space-between" : "end",
                                    flexDirection: "column"
                                }
                    }
                >
                    <div style={{ marginBottom: "0.5rem", display: "flex", justifyContent: "center" }}>{icon}</div>
                    <div className="d-flex align-items-center justify-content-center">
                        <div className={styles["min-w-span"]} style={{ lineHeight: 0.7 }}>
                            <span className={styles["span"]} style={{ color: colorText, fontWeight: "bold" }}>{title}</span>
                        </div>
                    </div>
                </Link>
                :
                <a
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    style={
                        topLeft ?
                            {
                                gridColumn: "1 / span 2",
                                gridRow: "1",
                                justifySelf: "center",
                                position: "relative",
                                textDecoration: "none",
                                display: "flex",
                                justifyContent: spaceBetween ? "space-between" : "end",
                                flexDirection: "column"
                            } : topRight ?
                                {
                                    gridColumn: "2 / span 2",
                                    gridRow: "1",
                                    justifySelf: "center",
                                    position: "relative",
                                    textDecoration: "none",
                                    display: "flex",
                                    justifyContent: spaceBetween ? "space-between" : "end",
                                    flexDirection: "column"
                                } :
                                {
                                    position: "relative",
                                    textDecoration: "none",
                                    display: "flex",
                                    justifyContent: spaceBetween ? "space-between" : "end",
                                    flexDirection: "column"
                                }
                    }
                >
                    <div style={{ marginBottom: "0.5rem", display: "flex", justifyContent: "center" }}>{icon}</div>
                    <div className="d-flex align-items-center justify-content-center">
                        <div className={styles["min-w-span"]} style={{ lineHeight: 0.7 }}>
                            <span className={styles["span"]} style={{ color: colorText, fontWeight: "bold" }}>{title}</span>
                        </div>
                    </div>
                </a>
    );
};

export default LinkPersonalizado7;
